import { render, staticRenderFns } from "./personalTermsPopup.vue?vue&type=template&id=4bc67e4e&scoped=true&"
import script from "./personalTermsPopup.vue?vue&type=script&lang=js&"
export * from "./personalTermsPopup.vue?vue&type=script&lang=js&"
import style0 from "./personalTermsPopup.vue?vue&type=style&index=0&id=4bc67e4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc67e4e",
  null
  
)

export default component.exports